import HomeOutlined from "@mui/icons-material/HomeOutlined";
import SpaceDashboardOutlined from "@mui/icons-material/SpaceDashboardOutlined";
import FactCheckOutlined from "@mui/icons-material/FactCheckOutlined";
import GroupOutlined from "@mui/icons-material/GroupOutlined";
import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import ShieldOutlined from "@mui/icons-material/ShieldOutlined";
import CrisisAlertOutlined from "@mui/icons-material/CrisisAlertOutlined";
import CorporateFareOutlined from "@mui/icons-material/CorporateFareOutlined";
import CardMembershipOutlined from "@mui/icons-material/CardMembershipOutlined";

import { ROLES } from "../../helpers/constants";

/**
 * Per-role primary navigation for the shared shell.
 *
 * These reproduce EXACTLY the destinations reachable per role today — no
 * information-architecture change:
 *  - Company Admin  → the SidebarOrgAdmin items + the Playbooks top-bar link
 *  - State DOT Admin → the SidebarStateAdmin items
 *  - Company Employee → derived from userRoutes reachable by employees + top-bar links
 *  - Platform Admin  → derived from the super-admin userRoutes
 *
 * `match` optionally lists extra path prefixes that should highlight the item
 * (e.g. sub-routes of an area).
 */
const NAV_BY_ROLE = {
  [ROLES.COMPANY_ADMIN]: [
    { key: "dashboard", label: "Dashboard", path: "/admin-dashboard", icon: SpaceDashboardOutlined },
    { key: "assessments", label: "Assessments", path: "/admin-survey-list", icon: FactCheckOutlined, match: ["/admin-survey-questionnaire"] },
    { key: "users", label: "User Management", path: "/user-management", icon: GroupOutlined },
    { key: "organization", label: "Organization Profile", path: "/admin-organization-profile", icon: BusinessOutlined },
    { key: "controls", label: "Control Library", path: "/control-library", icon: ShieldOutlined },
    { key: "incidents", label: "Incident Response", path: "/playbooks", icon: CrisisAlertOutlined, match: ["/playbooks"] },
  ],
  [ROLES.COMPANY_EMPLOYEE]: [
    { key: "dashboard", label: "Dashboard", path: "/dashboard", icon: SpaceDashboardOutlined },
    { key: "assessments", label: "Assessments", path: "/survey", icon: FactCheckOutlined },
    { key: "controls", label: "Control Library", path: "/employee-control-library", icon: ShieldOutlined },
    { key: "incidents", label: "Incident Response", path: "/playbooks", icon: CrisisAlertOutlined, match: ["/playbooks"] },
  ],
  [ROLES.STATE_DOT_ADMIN]: [
    { key: "dashboard", label: "Dashboard", path: "/state-admin-dashboard", icon: SpaceDashboardOutlined },
    { key: "organizations", label: "Organizations", path: "/state-admin-organizations", icon: CorporateFareOutlined },
  ],
  [ROLES.PLATFORM_ADMIN]: [
    { key: "home", label: "Home", path: "/super-admin", icon: HomeOutlined, match: ["/super-admin-member-organizations-list", "/super-admin-organisation-profile"] },
    { key: "membership", label: "Membership Portal", path: "/super-admin-membership-portal", icon: CardMembershipOutlined },
  ],
};

/** Nav items for a role (empty array if role is unknown/unauthenticated). */
export function getNavForRole(role) {
  return NAV_BY_ROLE[role] || [];
}

/** Which nav item (if any) a pathname belongs to. */
export function activeNavKey(items, pathname) {
  const hit = items.find((item) => {
    if (pathname === item.path || pathname.startsWith(`${item.path}/`)) return true;
    return (item.match || []).some(
      (p) => pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(p)
    );
  });
  return hit ? hit.key : null;
}

export default NAV_BY_ROLE;
